import classNames from 'classnames';
import React from 'react';
import './styles.css';
import NotificationsFormWarning from '../../scenes/Form/components/AccountSettingsForm/components/NotificationsFormWarning';

const FormRadio = ({ options, name, onChange, value, mark, error, wide = false }) => {
  return (
    <div className={'form-radio'}>
      {options.map((option, index) => {
        return (
          <div key={index} className="form-radio__item">
            <label className={classNames('form-radio__input', {'form-radio__input--wide': wide})}>
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={onChange}
              />
              <span className="form-radio__body">
                <span className="form-radio__label">
                  <span className="form-radio__label-text">
                    {option.label || option.value}
                    {mark && index === options.length - 1 && (
                      <span className="form-radio__mark">
                        {mark}
                      </span>
                    )}
                  </span>
                  {option.helpText && (
                    <span className={'form-radio__help'}>{option.helpText}</span>
                  )}
                  {!!error && index === options.length - 1 && (
                    <NotificationsFormWarning>{error}</NotificationsFormWarning>
                  )}
                </span>
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default FormRadio;
